module.exports = __webpack_public_path__ + "img/hr-lab.f34cc777.png";